import { DifficultyLevel, GamePhase } from '../types';

export interface PhaseLadderShortage {
  difficulty: DifficultyLevel;
  required: number;
  available: number;
}

const DIFFICULTY_LABELS: Record<DifficultyLevel, string> = {
  0: 'Fácil',
  1: 'Media',
  2: 'Difícil',
};

const pluralize = (count: number, word: string): string => (count === 1 ? word : `${word}s`);

/**
 * Compares how many phases are configured at each difficulty against how many
 * questions are actually available there, so a host can't start a game where a
 * phase would silently render a blank, unanswerable question.
 */
export const getPhaseLadderShortages = (
  gamePhases: GamePhase[],
  availableByDifficulty: Record<DifficultyLevel, number>
): PhaseLadderShortage[] => {
  const requiredByDifficulty: Record<DifficultyLevel, number> = { 0: 0, 1: 0, 2: 0 };
  gamePhases.forEach((phase) => {
    const difficulty = phase.difficulty as DifficultyLevel;
    requiredByDifficulty[difficulty] = (requiredByDifficulty[difficulty] ?? 0) + 1;
  });

  return ([0, 1, 2] as DifficultyLevel[])
    .filter((difficulty) => requiredByDifficulty[difficulty] > (availableByDifficulty[difficulty] ?? 0))
    .map((difficulty) => ({
      difficulty,
      required: requiredByDifficulty[difficulty],
      available: availableByDifficulty[difficulty] ?? 0,
    }));
};

export const formatPhaseLadderWarning = (shortage: PhaseLadderShortage): string => {
  const label = DIFFICULTY_LABELS[shortage.difficulty];
  const availableWord = pluralize(shortage.available, 'pregunta');
  const availableAdj = pluralize(shortage.available, 'disponible');
  const requiredWord = pluralize(shortage.required, 'fase');
  const requiredAdj = pluralize(shortage.required, 'configurada');
  return `Solo hay ${shortage.available} ${availableWord} "${label}" ${availableAdj}, pero hay ${shortage.required} ${requiredWord} ${requiredAdj} con esa dificultad.`;
};
